import { render } from "./navList.vue?vue&type=template&id=6637b988"
import script from "./navList.vue?vue&type=script&lang=js"
export * from "./navList.vue?vue&type=script&lang=js"

import "./navList.vue?vue&type=style&index=0&id=6637b988&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__